import { Component, input, OnInit, output } from '@angular/core';
import { MessageTemplate } from '../../../../../../shared/models/configuration.model';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';

@Component({
  selector: 'app-message-template-editor',
  imports: [
    MatFormField,
    MatLabel,
    MatInput,
    FormsModule,
    MatIconButton,
    MatTooltip,
    MatIcon,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger,
    CdkTextareaAutosize,
  ],
  templateUrl: './message-template-editor.component.html',
  styleUrl: './message-template-editor.component.scss',
})
export class MessageTemplateEditorComponent implements OnInit {
  template = input<MessageTemplate>();
  isNew = input<boolean>(false);

  editedTemplate: MessageTemplate;

  templateDeleted = output<void>();
  templateUpdated = output<MessageTemplate>();

  beingEdited: boolean;

  constructor() {}

  ngOnInit(): void {
    if (this.isNew()) {
      this.edit();
    } else {
      this.beingEdited = false;
    }
  }

  edit() {
    this.beingEdited = true;
    this.editedTemplate = { ...this.template() };
  }

  update() {
    this.beingEdited = false;
    this.templateUpdated.emit(this.editedTemplate);
  }

  cancel() {
    this.beingEdited = false;
    if (this.isNew()) {
      this.templateDeleted.emit();
    }
  }
}
